export function showErrorToast(vueInstance, error) {
  vueInstance.$toast.add({
    severity: 'error',
    summary: 'Error',
    detail: error?.message || 'An error occurred.',
    life: 5000,
  });
}

// export function showSuccessToast(vueInstance, message) {
//   vueInstance.$toast.add({
//     severity: 'success',
//     summary: 'Success',
//     detail: message || 'Success.',
//     life: 5000,
//   });
// }